<script>
import ServiceRow from "../ServiceRow.vue";
import AppointmentStore from "../../../mixins/appointment-store";

export default {
    name: "Services",

    props: {
        servicesText: String,
    },

    components: {ServiceRow},

    mixins: [AppointmentStore],
}
</script>

<template>
    <form class="vue-services-overview">
        <div v-html="servicesText"></div>

        <div class="services" style="gap: 0.5rem; display: grid">
            <ServiceRow v-for="service in appointmentStore.services" :key="service.id" :request-offer="requestOffer" :service="service" />
        </div>

        <div class="mt-4">
            <label for="other">En/of overige werkzaamheden (optioneel)</label>

            <textarea
                v-model="appointmentStore.otherWork"
                name="other"
                id="other"
                rows="5"
                class="d-block w-100"
            ></textarea>
        </div>

        <button class="btn-arrow mt-4" @click="appointmentStore.goToStep(4)" :disabled="appointmentStore.selectedServiceIds.length === 0">
            Stap 4 - Contactgegevens
        </button>
    </form>
</template>